import { LegacyPage } from './LegacyPage';

export default LegacyPage;
